/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable eqeqeq */
import { useState } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'antd';
import { useDispatch } from 'react-redux';
import {
  boxShadow, primaryHeadingColor, wLight, secondaryFont, maxWidth, retina, maxTablet, maxMobile,
} from 'Utils/utilsStyle';
import { Executive } from 'Types/PersonTypes';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import {
  backgroundColorParsing, IsMobile, IsTablet, valueToObject,
} from 'Utils/UtilityFunctions';
import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import BackIcon from 'Components/common/assets/svgIcons/BackIcon';
import { actions as flurryActions } from 'Slice/HelperSlice';
import GlobalButton from '../../common/components/GlobalButton';
import PeopleIcon from '../../common/assets/svgIcons/PeopleIcon';
import PeopleCardLarge from '../../common/components/PeopleCardLarge';
import DragWrapper from './DragWrapper';

type Props = {
  people: Executive[]
  isDrag: (d: boolean) => void
  title?: string
  loading: boolean
} & typeof defaultProps;

const defaultProps = {
  title: 'We’ve found some people you might be interested in…',
};

const Wrapper = styled.div`
  background-color: #fff;
  box-shadow: ${boxShadow};
  border-radius: 16px;
  padding: 23px;
  margin: 70px 0px;
  position: relative;
  z-index: 0;
  h4.recommended-name{
    color:${primaryHeadingColor};
    font-weight:${wLight};
    font-family:${secondaryFont};
    margin-bottom:0;
    font-size:22px;
    line-height: 38px;
    @media all and (max-width: ${maxWidth}) , ${retina} { 
     font-size: 18px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 14px;
      line-height: 19px;
    }
  }
  .user-images{
    position: relative;
    margin-right:13px;
    z-index:0;
    > div{
        padding:2px !important;
        &:nth-child(1){
          z-index:5;
        }
        &:nth-child(2){
          z-index:4;
          margin-left: -10px;
        }
        &:nth-child(3){
          z-index:3;
          margin-left: -10px;
        }
        &:nth-child(4){
          z-index:2;
          margin-left: -10px;
        }
        &:nth-child(5){
          z-index:1;
          margin-left: -10px;
        }
    }
  }
  .recommended-list{
    margin: 0px;
    padding-top: 30px;
  }
  .recommeded-hide{
    overflow:hidden;
    height:0px !important;
    margin:0;
    opacity:0 !important;
    padding-top: 0px !important;
  }
  .animate-height{
    height:auto;
    opacity:1;
    transition-duration: 1s;
  }
  .ant-collapse-content {
    transition: 0.5s ease all;
  }
  .ant-collapse-header, .ant-collapse-content-box {
    padding: 0px !important;
    align-items: center;
  }
  .ant-collapse-header {
    z-index: 1;
  }
  .heading-icon {
    display: block;
    margin-right: 15px;
    margin-top: 5px;
  }
  .ant-collapse-item {
    .ant-collapse-arrow {
      display: none !important;
    }
    .heading-collapse-c {
      .heading-icon {
        display: none;
      }
    }
    &.ant-collapse-item-active {
      .user-images {
        display: none;
      }
      .heading-collapse-c {
       
      }
      .ant-collapse-extra {
        display: none;
      }
    }
  }
  .un-collapse-btn {
    position: absolute;
    right: 23px;
    top: 21px;
    z-index: 2;
    @media all and (max-width: ${maxWidth}),${retina} {
      top: 28px;
    }
  }
  .body-collapse {
    &.one-line-persons {
      .ant-col {
        &:nth-last-child(1) {
          @media all and (max-width: 1440px){
            display: none !important;
          }
        }
      }
    }
  } 
  .header-collapse, .body-collapse {
    overflow: hidden;
    &.h-0 {
      height: 0px;
      transition: 0.5s ease all;
    }
    &.h-auto {
      height: auto;
      transition: 0.5s ease all;
    }
  }
  .see-recommended-mob-div {
    @media all and (max-width: ${maxMobile}) {
      padding-top: 15px;
      button {
      width: 100%;
      display: flex;
      justify-content: center;
      }
    }
  }
`;

const SeeRecommended = function SeeRecommended(props: Props) {
  const {
    people, title, loading, isDrag,
  } = props;
  const dispatch = useDispatch();
  const [seeAll, setSeeAll] = useState(false);
  const [toggle, setToggle] = useState(false);
  const mapItems = (people.length > 6 && !seeAll) ? 6 : people.length;
  const number = (IsTablet() ? 4 : 5);
  const isMob = IsMobile();
  const host = window.location.href;

  const seeRecommended = () => {
    if (!toggle) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('peopleDashboard_see_recommended_clicked', 0, {
          host,
        }),
      ));
    }
    setToggle(!toggle);
  };

  const seeAllRecommended = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('peopleDashboard_see_all_recommended_clicked', 0, {
        host,
      }),
    ));
    setSeeAll(true);
  };

  return (
    <Wrapper>
      <div className={`header-collapse ${toggle ? 'minimize' : 'expanded'}`}>
        <div className="d-flex heading-collapse-c">
          {toggle ? (
            <div className="heading-icon">
              {isMob
                ? seeAll && people.length > 6
                  ? (
                    <div onClick={() => setSeeAll(false)}>
                      <BackIcon />
                    </div>
                  ) : (
                    <div onClick={() => setToggle(!toggle)}>
                      <BackIcon />
                    </div>
                  )
                : <PeopleIcon />}
            </div>
          )
            : (
              <div className="d-flex align-items-center user-images">
                {loading ? (
                  <>
                    {[1, 2, 3, 4, 5].map(() => <SkeletonCustom width="40px" height="40px" diameter="50%" margin="0px" />)}
                  </>
                )
                  : people.slice(0, number).map((person) => (
                    <PeopleWidgetWithOutHolo
                      key={person.personId}
                      logo={person.personImage}
                      persona={person.archeType.color}
                      wrapperColor={backgroundColorParsing(person.personalityTypes)}
                      diameter="40px"
                      diameterSm="40px"
                      diameterXsm="40px"
                      marginSm="0px 3px 0px 3px"
                      margin="0"
                      personId={person.personId}
                      type={person.personType}
                      showPersonName
                      personForHover
                      personName={person.personName}
                    />
                  ))}
              </div>
            )}
          <h4
            className="recommended-name d-flex align-items-center c-pointer"
            onClick={() => setToggle(!toggle)}
          >
            {loading ? (<SkeletonCustom width="500px" height="20px" margin="0px" />) : title}
          </h4>
        </div>
        {!IsMobile() && (
          <div>
            {toggle ? (
              <>
                {!seeAll && people.length > 6 ? (
                  <GlobalButton
                    title="See All Recommended"
                    bgColor="#001760"
                    borderRadius="25px"
                    PaddingSm="5px 15px 5px 10px"
                    onButtonClick={seeAllRecommended}
                    buttonClassName="un-collapse-btn"
                  />
                ) : null}
                {
                  seeAll && people.length > 6 ? (
                    <GlobalButton
                      title="See Less Recommended"
                      buttonClassName="close-see-all un-collapse-btn"
                      bgColor="#001760"
                      borderRadius="25px"
                      PaddingSm="5px 15px 5px 10px"
                      onButtonClick={() => setSeeAll(false)}
                    />
                  ) : null
                }
              </>
            )
              : !loading && (
                <GlobalButton
                  title="See Recommended"
                  bgColor="#001760"
                  borderRadius="25px"
                  PaddingSm="5px 15px 5px 10px"
                  buttonClassName="un-collapse-btn"
                  onButtonClick={seeRecommended}
                />
              )}
          </div>
        )}
      </div>
      <div className={`body-collapse ${toggle ? 'h-auto' : 'h-0'} ${seeAll ? 'full-data' : 'one-line-persons'}`}>
        <Row gutter={[24, 24]} className="Grid-width-row recommended-list animate-height">
          {people.slice(0, mapItems).map((person, i) => (
            (
              <Col xxl={{ span: 4 }} xl={{ span: 4 }} lg={{ span: 6 }} className="gutter-row">
                <DragWrapper key={person?.personId} isDrag={isDrag}>
                  <PeopleCardLarge
                    isBoxResOne
                    key={`${person.personId}${i}`}
                    persona={person.archeType.color}
                    logo={person.personImage}
                    personName={person.personName}
                    tag={person.personDesignation}
                    personaType={person.archeType.name}
                    hidePersonality={false}
                    wrapperColor={backgroundColorParsing(person.personalityTypes)}
                    personalityTypesColors={person.personalityTypes}
                    personId={person.personId}
                    personality={person.personType}
                    personAddedFlag={person.personAdded}
                    company={(person).companyName}
                    diameterSm="210px"
                    tagTextPadding="0px 20px"
                    isRecommended
                    companyId={person?.companyId}
                    location={person?.location}
                  />
                </DragWrapper>
              </Col>
            )
          ))}
        </Row>
      </div>
      {IsMobile() && (
        <div className="see-recommended-mob-div">
          {toggle ? (
            <div>
              {!seeAll && people.length > 6 ? (
                <GlobalButton
                  title="See All Recommended"
                  bgColor="#001760"
                  borderRadius="25px"
                  PaddingSm="5px 15px 5px 10px"
                  onButtonClick={seeAllRecommended}
                />
              ) : null}
            </div>
          )
            : !loading && (
              <GlobalButton
                title="See Recommended"
                bgColor="#001760"
                borderRadius="25px"
                PaddingSm="5px 15px 5px 10px"
                onButtonClick={seeRecommended}
              />
            )}
        </div>
      )}
    </Wrapper>
  );
};
SeeRecommended.defaultProps = defaultProps;
export default SeeRecommended;
